import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useCallback, useState } from 'react'
import React from 'react'
import Image from 'next/image'
import styles from './kdt-frontend-14th.module.scss'

interface ICurriculumProps {
  contents: {
    id: number
    step: string
    title: string
    iconUrl: string[]
    desc: string
    descList: string[]
  }
  idx: number
}

const CurriculumAccordion = ({ contents, idx }: ICurriculumProps) => {
  const defaultOpen = idx === 0
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const onOpenHandler = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  return (
    <li className="group list-none overflow-hidden px-4 pt-2.5 lg:px-8" onClick={onOpenHandler}>
      <div className="cursor-pointer list-none group-open:pb-1">
        <div className={`${styles.curriculum_accordion_dot_box} flex flex-row items-center gap-5`}>
          <div
            className={`${
              isOpen
                ? 'border-[2px] border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                : 'border-[2px] border-label-alternative bg-gray-900'
            } z-10 flex h-2 w-2 shrink-0 items-center justify-center rounded-full`}
          >
            <span></span>
          </div>
          <div
            className={`${
              isOpen ? 'rounded-t-lg' : 'rounded-lg'
            } flex w-full items-center justify-between gap-x-3 bg-trueGray-800 px-4 py-3`}
          >
            <div className="flex flex-col">
              {contents.step && (
                <p className="text-xs font-bold text-yellow-450">{contents.step}</p>
              )}
              <h5
                className={`${
                  isOpen ? 'text-white' : 'text-label-alternative'
                } text-lg font-bold leading-normal`}
              >
                {contents.title}
              </h5>
            </div>
            <ChevronDownIcon
              className={`${
                isOpen ? 'rotate-180 transform' : ''
              } ml-auto h-auto w-4 shrink-0 grow-0 text-label-alternative lg:w-8`}
            />
          </div>
        </div>
      </div>
      {/* open */}
      {isOpen && (
        <>
          <div className="ml-7 flex flex-1 flex-col gap-4 rounded-b-lg bg-trueGray-800 px-4 pb-3 pt-1">
            <div className="flex flex-row flex-wrap gap-2">
              {contents.iconUrl?.map(url => (
                <div key={`${contents.id}-${url}`} className="max-w-fit">
                  <Image
                    src={url}
                    width={84}
                    height={84}
                    className="!relative object-cover"
                    alt={`${contents.title} icon`}
                  />
                </div>
              ))}
            </div>
            <div className="flex w-full flex-col bg-[#1F1F1F] px-4 py-3">
              <h6 className="whitespace-pre-line text-sm font-semibold leading-normal text-white">
                {contents.desc}
              </h6>
              <ul className="mt-4 flex flex-col gap-0.5 border-t border-[#3D3D3D] pt-4">
                {contents.descList?.map(item => (
                  <li key={`${contents.id}-${item}`}>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive`}
                    >
                      {item}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </>
      )}
    </li>
  )
}

export default CurriculumAccordion
